/* How many presses a slide holds back.

   Counted from the data, not from the DOM: a slide knows how many reveals it
   has before it is drawn, which is what lets the bar show the dots and the
   arrow decide between revealing and advancing without measuring anything.

   OWNED BY ITEM 8 OF docs/plan/00-prestavba-2026-08.md. */

import { createContext, useContext } from "react";
import type { Block } from "../../lib/types";

export function maxStep(blocks: Block[]): number {
  let max = 0;
  for (const b of blocks) {
    max = Math.max(max, b.step ?? 0);
    if (b.k === "steps") {
      for (const s of b.steps) max = Math.max(max, s.s ?? 0);
    }
    /* An `ask` with nothing held back is a question that closes the slide, and
       the next slide answers it. Only one that carries an answer costs a press. */
    if (b.k === "ask" && (b.answer || b.body || b.note?.length)) {
      max = Math.max(max, b.astep ?? 1);
    }
  }
  return max;
}

/* Outside the deck everything is revealed, so nothing shown on the projector is
   missing on the page or on paper. */
export const RevealContext = createContext<number>(Number.POSITIVE_INFINITY);

export function useReveal(): number {
  return useContext(RevealContext);
}

export function revealed(step: number | undefined, at: number): boolean {
  return step == null || step <= at;
}
